var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LostAmountIcon = function (props) {
    return (_jsxs("svg", __assign({ width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("rect", { width: "80", height: "80", rx: "40", fill: "#EFF0F7" }), _jsx("path", { d: "M53.3333 40V48.3333C53.3333 52.9357 49.6024 56.6667 45 56.6667H33.3333C28.731 56.6667 25 52.9357 25 48.3333V40M48.1489 29.258L39.5491 20.6006L30.9492 29.258M39.5478 22.0999V40.4332", stroke: "#CA024F", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })] })));
};
export default LostAmountIcon;
